import { Text } from '@savvy-kit/foundations/text';
import Banner from '@savvy-kit/patterns/banner';

import { LogoutAsButton } from './logout-as-button';

export function LogoutAsSplash() {
  const inPreviewEnv = process.env['NEXT_PUBLIC_VERCEL_ENV'] === 'preview';
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="flex flex-col gap-4">
        <Text>
          It looks like you are still logged in as a client. Please log out of their account to return to your advisor
          dashboard.
        </Text>
        {inPreviewEnv && (
          <Banner
            variant="destructive"
            description="Vercel Preview environment is not supported for login-as, please try in production."
          />
        )}
        <LogoutAsButton useGenericCopy />
      </div>
    </div>
  );
}
